import { motion } from "framer-motion";
import { GraduationCap, BadgeCheck } from "lucide-react";
import { EDUCATION, CERTIFICATIONS } from "../data/content";
import { MaskedLines } from "./Reveal";

export const KnowledgeVault = () => (
  <section data-testid="knowledge-vault" className="relative overflow-hidden py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <p className="text-xs font-bold uppercase tracking-[0.32em] text-[#00BFA5]">Education & Certifications</p>
      <h2 className="mt-5 font-display text-4xl font-black tracking-tight text-[#0A192F] md:text-6xl">
        <MaskedLines lines={["The Knowledge Vault"]} />
      </h2>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2" style={{ perspective: 1400 }}>
        {EDUCATION.map((e, i) => (
          <motion.div
            key={e.title}
            initial={{ opacity: 0, rotateY: -18, y: 30 }}
            whileInView={{ opacity: 1, rotateY: 0, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ rotateY: 5, y: -6 }}
            className="glass flex items-start gap-5 rounded-3xl p-8"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#0A192F] text-[#00E5FF]">
              <GraduationCap size={22} />
            </span>
            <div>
              <p className="font-display text-lg font-black leading-snug text-[#0A192F]">{e.title}</p>
              <p className="mt-2 text-sm font-semibold text-[#4A5568]">{e.org}</p>
              <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.22em] text-[#00BFA5]">{e.year}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" style={{ perspective: 1400 }}>
        {CERTIFICATIONS.map((c, i) => (
          <motion.div
            key={c.title}
            initial={{ opacity: 0, rotateY: 16, y: 30 }}
            whileInView={{ opacity: 1, rotateY: 0, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ rotateY: -6, y: -6 }}
            className="glass rounded-3xl p-6"
            data-testid={`cert-card-${i}`}
          >
            <BadgeCheck size={20} className="text-[#00BFA5]" />
            <p className="mt-4 font-display text-base font-black leading-snug text-[#0A192F]">{c.title}</p>
            <p className="mt-2 text-xs font-semibold text-[#4A5568]">{c.org}</p>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.22em] text-[#0A192F]/45">{c.year}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
